import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnInit {
  onMessageSent: any;
  onClose: any;

  @Input() quote_id: any = null;
  @Input() qouteItemId: any = null;
  @Input() order: any = null;
  @Input() item: any = null;

  constructor() { }

  ngOnInit() {
  }

  sendMessage(){
    this.onMessageSent();
  }
  closeModal(){
    this.onClose();
  }
}
